import { render, staticRenderFns } from "./migracao.vue?vue&type=template&id=96811f12&"
import script from "./migracao.vue?vue&type=script&lang=js&"
export * from "./migracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports